import React, { FC, Fragment } from 'react';
import { ENUM_ITEM_TYPES } from '../../helpers/enums';
import { OrderType } from '../../helpers/types';
import CardHeaderTag from './cardHeaderTag';
import useLayoutContext from '../../contexts/layout.context';
import { isItemTypeAll, isItemTypeFood, isItemTypeShop } from '../../helpers/permissions.service';

const FrontDeskTags = ({ order }: { order: OrderType }) => {
  const type = order?.calculated_order?.item_type;
  return (
    <Fragment>
      {isItemTypeFood(type) && <CardHeaderTag type='food' />}
      {isItemTypeShop(type) && <CardHeaderTag type='shop' />}
      {isItemTypeAll(type) && (
        <Fragment>
          <CardHeaderTag type='food' />
          <CardHeaderTag type='shop' />
        </Fragment>
      )}
    </Fragment>
  );
};

const OtherRoleTags = ({ order }: { order: OrderType }) => {
  const { permissions } = useLayoutContext();
  const { isPackagingRole, isKitchenRole, isShopRole, isAdminRole } = permissions;
  const isAll = order?.calculated_order?.item_type === ENUM_ITEM_TYPES.ALL;
  const shopType = order?.kitchen_prepared ? 'foodReady' : 'food';
  const kitchenType = order?.shop_prepared ? 'shopReady' : 'shop';

  return isAll ? (
    // showCardHeaderTag
    <Fragment>
      {isShopRole && <CardHeaderTag type={shopType} />}
      {isKitchenRole && <CardHeaderTag type={kitchenType} />}
      {isPackagingRole && <CardHeaderTag type={kitchenType} />}
      {isAdminRole && (
        <Fragment>
          <CardHeaderTag type='food' />
          <CardHeaderTag type='shop' />
        </Fragment>
      )}
    </Fragment>
  ) : (
    <span />
  );
};

const ItemTypeTags: FC<{ order: OrderType }> = ({ order }) => {
  // showFrontDeskTag
  const { permissions } = useLayoutContext();
  const { isFrontdeskRole } = permissions;
  return isFrontdeskRole ? <FrontDeskTags order={order} /> : <OtherRoleTags order={order} />;
};

export default ItemTypeTags;
